import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IPortfolioMessage } from '@core/interfaces/iportfolio-message';
import { IPortfolioUser } from '@core/interfaces/iportfolio-user';
import { PortfolioMessageService } from '@core/services/portfolio-message.service';
import { ToastService } from '@core/services/toast.service';
import { TranslocoService } from '@jsverse/transloco';
import { UserService } from '@core/services/user.service';
import { take } from 'rxjs';

@Component({
    selector: 'drdp-portfolio-message-box',
    templateUrl: './portfolio-message-box.component.html',
    styleUrls: ['./portfolio-message-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PortfolioMessageBoxComponent implements OnInit {
  messageForm: FormGroup | any;

  get recipients() {
    return this.messageForm.get('recipients');
  }
  get message() {
    return this.messageForm.get('message');
  }

  constructor(
    private portfolioMessageService: PortfolioMessageService,
    private fb: FormBuilder,
    private toastService: ToastService,
    public dialogRef: MatDialogRef<PortfolioMessageBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translocoService: TranslocoService
  ) { }

  ngOnInit(): void {
    this.initializeForms();
  }

  initializeForms(): void {
    this.messageForm = this.fb.group({
      recipients: [null, Validators.required],
      message: [null, [Validators.required]],
    });

    if (this.data.recipientId) {
      this.recipients.setValue([this.data.recipientId]);
    }
  }

  onSend() { 
    if (this.messageForm.invalid) {
      this.toastService.error(this.translocoService.translate('user.dashboard.portfolio.toast.requiredFields'));
      return;
    }

    const payload: IPortfolioMessage = {
      portfolioId: this.data.portfolioId,
      studentClassEnrollmentId: this.data.enrollmentId,
      message: this.message.value,
      messageRecipients: this.recipients.value.map((userId: number) => ({ userId })),
    }

    this.portfolioMessageService.addNewMessage(
      payload, 
      this.translocoService.translate('user.dashboard.portfolio.messageBox.sentToast'))
      .pipe(take(1))
      .subscribe((res: boolean) => {
        if (res) this.dialogRef.close();
        else this.toastService.error(this.translocoService.translate('user.dashboard.portfolio.messageBox.sendFailedToast'));
      })

  }

  handleRecipientSelection(event: any): void {
    if (event.length > 10) {
      this.toastService.error(this.translocoService.translate('user.dashboard.portfolio.messageBox.tooManyRecipientsToast'));
      return;
    }
    const recipients = event?.map((recipient: IPortfolioUser) => recipient.id);
    this.recipients.setValue(recipients);
  }
}
